import {
    UNCLAIMED_PAYOUTS_RESPONSE,
    GET_UNCLAIMED_PAYOUTS_SUCCESS,
    UNCLAIMED_PAYOUTS_DATA,
    SUMMARY_INFO_RESPONSE,
    SCHEMES_RESPONSE,
} from './../types/portfolio';
import { ResponseBody } from '../middleware';
import { LOGOUT_SUCCESS, MOBILE_SESSION_FORCE_LOGOUT, MOBILE_SESSION_OUT } from '../types/login';
import {
    FETCH_PORTFOLIOS_SUCCESS,
    GET_AMC_DETIALS,
    PORTFOLIOS,
    PORTFOLIO_DATA_RESPONSE,
} from '../types/portfolio';
import { GET_AMC_LIST, GET_AMC_LIST_SUCCESS, SAVE_IMAGE_DATA } from '../types/nct';

const intiState: {
    portfolios: any;
    amcDetails: PORTFOLIO_DATA_RESPONSE | object;
    unclaimedPayouts: UNCLAIMED_PAYOUTS_RESPONSE | object;
    amcList: any;
    noNomineeFolios: string[];
} = {
    portfolios: {},
    amcDetails: {},
    unclaimedPayouts: {},
    amcList: [],
    noNomineeFolios: [],
};

function portfolio(state = intiState, action: PORTFOLIOS & ResponseBody<any>) {
    switch (action.type) {
        case FETCH_PORTFOLIOS_SUCCESS: {
            const { data = [], portfolio = [], ...rest }: any = action?.body || {};
            const _portfolio = {
                demat: portfolio.find((ele: SUMMARY_INFO_RESPONSE) => ele.isDemat === 'Y'),
                non_demat: portfolio.find((ele: SUMMARY_INFO_RESPONSE) => ele.isDemat === 'N'),
            };
            const filteredData: PORTFOLIO_DATA_RESPONSE[] = data.map((fund: any) => ({
                ...fund,
                summary: {
                    demat: fund.summary.find((ele: SUMMARY_INFO_RESPONSE) => ele.isDemat === 'Y'),
                    non_demat: fund.summary.find(
                        (ele: SUMMARY_INFO_RESPONSE) => ele.isDemat === 'N',
                    ),
                },
            }));
            const foliosWithNoNominees = filteredData.reduce((curr, { schemes }) => {
                const noNomineeFolios = schemes
                    .filter((scheme) => scheme.nomineeStatus === 'N')
                    .map((scheme) => scheme.folio);
                return [...curr, ...noNomineeFolios];
            }, [] as unknown as string[]);
            return {
                ...state,
                portfolios: {
                    ...rest,
                    portfolio: _portfolio,
                    data: filteredData,
                },
                noNomineeFolios: foliosWithNoNominees,
            };
        }
        case GET_AMC_DETIALS: {
            const { amc, type, assetType = null } = action.body;
            const { portfolios = {} }: any = state;
            const { data = [] } = portfolios;
            const isDematFund = type === 'demat';
            const _amcDetails: any = data.reduce(
                (prev: PORTFOLIO_DATA_RESPONSE[], fund: PORTFOLIO_DATA_RESPONSE) => {
                    if (
                        fund?.summary['demat']?.amc === amc ||
                        fund?.summary['non_demat']?.amc === amc
                    ) {
                        const { schemes, summary, ...rest } = fund;
                        let amcSchemes: SCHEMES_RESPONSE[] = [];
                        let summaryObject: any = {
                            amcName:
                                fund?.summary['demat']?.amcName ||
                                fund?.summary['non_demat']?.amcName,
                            costValue: 0,
                            currentMktValue: 0,
                            amc,
                        };
                        schemes.forEach((scheme: SCHEMES_RESPONSE) => {
                            let _isDematFund = scheme.isDemat === 'Y';

                            const cashSchemeAssetType = ['LIQUID', 'CASH'].includes(
                                scheme?.assetType?.toUpperCase(),
                            ); // need to be remove if cash and liquid are different
                            const _cashSelectedType = ['LIQUID', 'CASH'].includes(
                                assetType?.toUpperCase(),
                            ); // need to be remove if cash and liquid are different
                            if (
                                (isDematFund === _isDematFund || !type) &&
                                (!assetType ||
                                    (cashSchemeAssetType && _cashSelectedType) ||
                                    assetType?.toUpperCase() === scheme?.assetType?.toUpperCase())
                            ) {
                                amcSchemes = [...amcSchemes, scheme];
                                summaryObject = {
                                    ...summaryObject,
                                    costValue:
                                        Number(summaryObject.costValue) + Number(scheme.costValue),
                                    currentMktValue:
                                        Number(summaryObject.currentMktValue) +
                                        Number(scheme.currentMktValue),
                                };
                            }
                        });

                        return [
                            ...prev,
                            {
                                ...rest,
                                schemes: amcSchemes,
                                summary: summaryObject,
                            },
                        ];
                    }
                    return prev;
                },
                [],
            );

            const { schemes, summary } = _amcDetails[0] || {};
            const gainLoss =
                Number(summary?.currentMktValue || 0) - Number(summary?.costValue || 0);
            const gainLossPercentage =
                gainLoss !== 0 && !!Number(summary?.costValue)
                    ? (Number(gainLoss) * 100) / Number(summary?.costValue)
                    : 0;
            return {
                ...state,
                amcDetails: { schemes, summary: { ...summary, gainLoss, gainLossPercentage } },
            };
        }
        case GET_UNCLAIMED_PAYOUTS_SUCCESS: {
            const unclaimedPayoutsResp: UNCLAIMED_PAYOUTS_RESPONSE = action.body;
            const unclaimedPayouts: UNCLAIMED_PAYOUTS_DATA[] = unclaimedPayoutsResp.success || [];
            return { ...state, unclaimedPayouts };
        }
        case SAVE_IMAGE_DATA: {
            return { ...state, imageInfo: action.body };
        }
        case GET_AMC_LIST_SUCCESS: {
            return { ...state, amcList: action.body };
        }
        case MOBILE_SESSION_FORCE_LOGOUT:
        case MOBILE_SESSION_OUT:
        case LOGOUT_SUCCESS: {
            return intiState;
        }
        default:
            return state;
    }
}

export default portfolio;
